/**
 * The Reservations module's API layer.
 *
 * The list and read paths are simple. The module does not yet offer create or
 * update forms: reservations are created by the booking flow and PMS sync, and
 * their status is moved by the lifecycle endpoints.
 */

export const reservationEndpoints = {
  list: '/v1/reservations',
  detail: (reservationId: string): string =>
    `/v1/reservations/${encodeURIComponent(reservationId)}`,
  fullDetail: (reservationId: string): string =>
    `/v1/reservations/${encodeURIComponent(reservationId)}/details`,
} as const;
